<sc-scroll-pane *ngIf="showStations">
    <div class="stations-set-details-grid">

        <app-station-details class="station" (click)="selectStation(station)" [station]="station"
            [selected]="station===selectedStation" *ngFor="let station of filteredStations"></app-station-details>

    </div>
</sc-scroll-pane>